/**
 * Procurement Module Service
 * API service layer for Procurement screens
 * All API endpoints from API_REGISTRY.md
 */

import api from '../apiClient';

// ═══════════════════════════════════════════════════════════════════════════════
// SUPPLIER MASTER (4.1.1)
// ═══════════════════════════════════════════════════════════════════════════════
export const supplierMaster = {
  getAll: () => api.get('/api/SupplierMaster/api/V1/GetAllSuppliers'),
  getById: (supplierId) => api.get(`/api/SupplierMaster/api/V1/GetSupplierDetailsById?supplierId=${supplierId}`),
  save: (data) => api.post('/api/SupplierMaster/api/V1/SaveSupplierMaster', data),
  update: (data) => api.put('/api/SupplierMaster/api/V1/UpdateSupplierMaster', data),
  delete: (supplierId) => api.delete(`/api/SupplierMaster/api/V1/DeleteSupplierMaster?supplierId=${supplierId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SUPPLIER CONTRACTS (4.1.2)
// ═══════════════════════════════════════════════════════════════════════════════
export const supplierContracts = {
  getAll: () => api.get('/api/SupplierContracts/api/V1/GetAllContracts'),
  getById: (contractId) => api.get(`/api/SupplierContracts/api/V1/GetContractDetailsById?contractId=${contractId}`),
  save: (data) => api.post('/api/SupplierContracts/api/V1/SaveContract', data),
  update: (data) => api.put('/api/SupplierContracts/api/V1/UpdateContract', data),
  delete: (contractId) => api.delete(`/api/SupplierContracts/api/V1/DeleteContract?contractId=${contractId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// AGENT MASTER (4.1.3)
// ═══════════════════════════════════════════════════════════════════════════════
export const agentMaster = {
  getAll: () => api.get('/api/AgentMaster/api/V1/GetAllAgents'),
  getById: (agentId) => api.get(`/api/AgentMaster/api/V1/GetAgentDetailsById?agentId=${agentId}`),
  save: (data) => api.post('/api/AgentMaster/api/V1/SaveAgentMaster', data),
  update: (data) => api.put('/api/AgentMaster/api/V1/UpdateAgentMaster', data),
  delete: (agentId) => api.delete(`/api/AgentMaster/api/V1/DeleteAgentMaster?agentId=${agentId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// JOBBER MASTER (4.1.4)
// ═══════════════════════════════════════════════════════════════════════════════
export const jobberMaster = {
  getAll: () => api.get('/api/JobberMaster/api/V1/GetAllJobbers'),
  getById: (jobberId) => api.get(`/api/JobberMaster/api/V1/GetJobberDetailsById?jobberId=${jobberId}`),
  save: (data) => api.post('/api/JobberMaster/api/V1/SaveJobberMaster', data),
  update: (data) => api.put('/api/JobberMaster/api/V1/UpdateJobberMaster', data),
  delete: (jobberId) => api.delete(`/api/JobberMaster/api/V1/DeleteJobberMaster?jobberId=${jobberId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// TRANSPORTER MASTER (4.1.5)
// ═══════════════════════════════════════════════════════════════════════════════
export const transporterMaster = {
  getAll: () => api.get('/api/TransporterMaster/api/V1/GetAllTransporters'),
  getById: (transporterId) => api.get(`/api/TransporterMaster/api/V1/GetTransporterDetailsById?transporterId=${transporterId}`),
  save: (data) => api.post('/api/TransporterMaster/api/V1/SaveTransporterMaster', data),
  update: (data) => api.put('/api/TransporterMaster/api/V1/UpdateTransporterMaster', data),
  delete: (transporterId) => api.delete(`/api/TransporterMaster/api/V1/DeleteTransporterMaster?transporterId=${transporterId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// TAX GROUP MASTER (4.1.6)
// ═══════════════════════════════════════════════════════════════════════════════
export const taxGroupMaster = {
  getAll: () => api.get('/api/TaxGroup/api/V1/GetAllTaxGroups'),
  getDropdown: () => api.get('/api/TaxGroup/api/V1/GetTaxGroupDropDownDetails'),
  getById: (taxGroupId) => api.get(`/api/TaxGroup/api/V1/GetTaxGroupDetailsById?taxGroupId=${taxGroupId}`),
  save: (data) => api.post('/api/TaxGroup/api/V1/SaveTaxGroupMaster', data),
  update: (data) => api.put('/api/TaxGroup/api/V1/UpdateTaxGroupMaster', data),
  delete: (taxGroupId) => api.delete(`/api/TaxGroup/api/V1/DeleteTaxGroup?TaxGroupId=${taxGroupId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// TAX MASTER (4.1.7)
// ═══════════════════════════════════════════════════════════════════════════════
export const taxMaster = {
  getAll: () => api.get('/api/TaxMaster/api/v1/getDetails'),
  getById: (taxId) => api.get(`/api/TaxMaster/api/v1/GetDetailsById?tax_uid=${taxId}`),
  getGrid: () => api.get('/api/TaxMaster/api/v1/GetListOfGrid'),
  save: (data) => api.post('/api/TaxMaster/api/V1/Save', data),
  update: (data) => api.put('/api/TaxMaster/api/V1/Update', data),
  delete: (taxId) => api.delete(`/api/TaxMaster/api/V1/Delete?TaxId=${taxId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// TAILOR MASTER (4.1.8)
// ═══════════════════════════════════════════════════════════════════════════════
export const tailorMaster = {
  getAll: () => api.get('/api/TailorMaster/api/V1/GetAllTailors'),
  getById: (tailorId) => api.get(`/api/TailorMaster/api/V1/GetTailorDetailsById?tailorId=${tailorId}`),
  save: (data) => api.post('/api/TailorMaster/api/V1/SaveTailorMaster', data),
  update: (data) => api.put('/api/TailorMaster/api/V1/UpdateTailorMaster', data),
  delete: (tailorId) => api.delete(`/api/TailorMaster/api/V1/DeleteTailorMaster?tailorId=${tailorId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// UOM MASTER (4.1.11)
// ═══════════════════════════════════════════════════════════════════════════════
export const uomMaster = {
  getAll: () => api.get('/api/UOMMaster/api/v1/GetDetails'),
  getById: (uomId) => api.get(`/api/UOMMaster/api/v1/GetById?UOmId=${uomId}`),
  save: (data) => api.post('/api/UOMMaster/api/V1/Save', data),
  update: (data) => api.put('/api/UOMMaster/api/V1/Update', data),
  delete: (uomId) => api.delete(`/api/UOMMaster/api/V1/Delete?UOMId=${uomId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// SUB UOM MASTER (4.1.12)
// ═══════════════════════════════════════════════════════════════════════════════
export const subUomMaster = {
  getAll: () => api.get('/api/SubUOMMaster/api/v1/GetDetails'),
  getById: (subUomId) => api.get(`/api/SubUOMMaster/api/v1/GetById?SubUomId=${subUomId}`),
  save: (data) => api.post('/api/SubUOMMaster/api/V1/Save', data),
  update: (data) => api.put('/api/SubUOMMaster/api/V1/Update', data),
  delete: (subUomId) => api.delete(`/api/SubUOMMaster/api/V1/Delete?SubUOMId=${subUomId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE OFFICER MASTER (4.1.13)
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseOfficerMaster = {
  getAll: () => api.get('/api/PurchaseOfficerMaster/api/V1/GetAllPurchaseOfficers'),
  getById: (officerId) => api.get(`/api/PurchaseOfficerMaster/api/V1/GetPurchaseOfficerDetailsById?officerId=${officerId}`),
  save: (data) => api.post('/api/PurchaseOfficerMaster/api/V1/SavePurchaseOfficerMaster', data),
  update: (data) => api.put('/api/PurchaseOfficerMaster/api/V1/UpdatePurchaseOfficerMaster', data),
  delete: (officerId) => api.delete(`/api/PurchaseOfficerMaster/api/V1/DeletePurchaseOfficerMaster?officerId=${officerId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// HSN CODE MASTER (22.1.8)
// ═══════════════════════════════════════════════════════════════════════════════
export const hsnCodeMaster = {
  getAll: () => api.get('/api/HSNCodeMaster/api/V1/GetDetails'),
  getItemDetails: (hsnCodeName) => api.get(`/api/HSNCodeMaster/api/V1/GetHSNCodeItemDetails?HSNCodeName=${hsnCodeName}`),
  getTaxDetails: () => api.get('/api/HSNCodeMaster/api/V1/GetTaxDetails'),
  getById: (hsnId) => api.get(`/api/HSNCodeMaster/api/V1/GetDetailsById?HSNId=${hsnId}`),
  save: (data) => api.post('/api/HSNCodeMaster/api/V1/Save', data),
  update: (data) => api.put('/api/HSNCodeMaster/api/V1/Update', data),
  delete: (hsnId) => api.delete(`/api/HSNCodeMaster/api/V1/Delete?HSNId=${hsnId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - DIVISION MASTER (4.3.1)
// ═══════════════════════════════════════════════════════════════════════════════
export const divisionMaster = {
  getAll: () => api.get('/api/Division/api/V1/GetAllDivisions'),
  getById: (divisionId) => api.get(`/api/Division/api/V1/GetDivisionDetailsById?divisionId=${divisionId}`),
  save: (data) => api.post('/api/Division/api/V1/SaveDivisionMaster', data),
  update: (data) => api.put('/api/Division/api/V1/UpdateDivisionMaster', data),
  delete: (divisionId) => api.delete(`/api/Division/api/V1/DeleteDivisonMaster?divisionId=${divisionId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - DEPARTMENT MASTER (4.3.2)
// ═══════════════════════════════════════════════════════════════════════════════
export const departmentMaster = {
  getAll: () => api.get('/api/Department/api/V1/GetAllDepartments'),
  getById: (departmentId) => api.get(`/api/Department/api/V1/GetDepartmentDetailsById?deparmentId=${departmentId}`),
  save: (data) => api.post('/api/Department/api/V1/SaveDepartmentMaster', data),
  update: (data) => api.put('/api/Department/api/V1/UpdateDepartmentMaster', data),
  delete: (departmentId) => api.delete(`/api/Department/api/V1/DeleteDepartmentMaster?departmentId=${departmentId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - CATEGORY MASTER (4.3.3)
// ═══════════════════════════════════════════════════════════════════════════════
export const categoryMaster = {
  getAll: () => api.get('/api/CategoryMaster/api/V1/GetAllCategories'),
  getById: (catId) => api.get(`/api/CategoryMaster/api/V1/CategoryMasterGetById?CatId=${catId}`),
  save: (data) => api.post('/api/CategoryMaster/api/V1/Save', data),
  update: (data) => api.put('/api/CategoryMaster/api/V1/Update', data),
  delete: (categoryId) => api.delete(`/api/CategoryMaster/api/V1/Delete?CategoryId=${categoryId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - SUBCATEGORY MASTER (4.3.4)
// ═══════════════════════════════════════════════════════════════════════════════
export const subCategoryMaster = {
  getAll: () => api.get('/api/SubCategoryMaster/api/v1/GetDetails'),
  getById: (scmId) => api.get(`/api/SubCategoryMaster/api/v1/GetDetailsById?SCMUId=${scmId}`),
  save: (data) => api.post('/api/SubCategoryMaster/api/V1/Save', data),
  update: (data) => api.put('/api/SubCategoryMaster/api/V1/Update', data),
  delete: (scmId) => api.delete(`/api/SubCategoryMaster/api/V1/Delete?SCMUId=${scmId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - BRAND MASTER (4.3.5)
// ═══════════════════════════════════════════════════════════════════════════════
export const brandMaster = {
  getAll: () => api.get('/api/BrandMaster/api/V1/GetAllBrands'),
  getById: (brandId) => api.get(`/api/BrandMaster/api/V1/GetBrandDetailsById?brandId=${brandId}`),
  save: (data) => api.post('/api/BrandMaster/api/V1/Save', data),
  update: (data) => api.put('/api/BrandMaster/api/V1/Update', data),
  delete: (brandId) => api.delete(`/api/BrandMaster/api/V1/Delete?brandId=${brandId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - STYLE MASTER (4.3.6)
// ═══════════════════════════════════════════════════════════════════════════════
export const styleMaster = {
  getAll: () => api.get('/api/StyleMaster/api/V1/GetAllStyles'),
  getById: (styleId) => api.get(`/api/StyleMaster/api/V1/GetStyleDetailsById?styleId=${styleId}`),
  save: (data) => api.post('/api/StyleMaster/api/V1/SaveStyle', data),
  update: (data) => api.put('/api/StyleMaster/api/V1/UpdateStyle', data),
  delete: (styleId) => api.delete(`/api/StyleMaster/api/V1/DeleteStyle?styleId=${styleId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - SIZE MASTER (4.3.7)
// ═══════════════════════════════════════════════════════════════════════════════
export const sizeMaster = {
  getAll: () => api.get('/api/SizeMaster/api/v1/GetAllDetails'),
  getById: (sizeId) => api.get(`/api/SizeMaster/api/v1/GetDetailsById?SizeId=${sizeId}`),
  save: (data) => api.post('/api/SizeMaster/api/v1/SaveDetails', data),
  update: (data) => api.put('/api/SizeMaster/api/v1/Update', data),
  delete: (sizeId) => api.delete(`/api/SizeMaster/api/V1/Delete?SizeId=${sizeId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - COLOR MASTER (4.3.8)
// ═══════════════════════════════════════════════════════════════════════════════
export const colorMaster = {
  getAll: () => api.get('/api/ColorMaster/api/v1/GetDetails'),
  getById: (colorId) => api.get(`/api/ColorMaster/api/v1/GetDetailsById?ColorId=${colorId}`),
  save: (data) => api.post('/api/ColorMaster/api/V1/Save', data),
  update: (data) => api.put('/api/ColorMaster/api/V1/Update', data),
  delete: (colorId) => api.delete(`/api/ColorMaster/api/V1/Delete?ColorId=${colorId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM ATTRIBUTES - DESIGN MASTER (4.3.9)
// ═══════════════════════════════════════════════════════════════════════════════
export const designMaster = {
  getAll: () => api.get('/api/DesignMaster/api/V1/GetAllDesigns'),
  getById: (designId) => api.get(`/api/DesignMaster/api/V1/GetDesignDetailsById?designId=${designId}`),
  save: (data) => api.post('/api/DesignMaster/api/V1/SaveDesignMaster', data),
  update: (data) => api.put('/api/DesignMaster/api/V1/UpdateDesignMaster', data),
  delete: (designId) => api.delete(`/api/DesignMaster/api/V1/DeleteDesignMaster?designId=${designId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// MATERIAL MASTER (4.3.10)
// ═══════════════════════════════════════════════════════════════════════════════
export const materialMaster = {
  getAll: () => api.get('/api/MaterialMaster/api/V1/GetAllMaterials'),
  getById: (materialId) => api.get(`/api/MaterialMaster/api/V1/GetMaterialDetailsById?materialId=${materialId}`),
  save: (data) => api.post('/api/MaterialMaster/api/V1/SaveMaterialMaster', data),
  update: (data) => api.put('/api/MaterialMaster/api/V1/UpdateMaterialMaster', data),
  delete: (materialId) => api.delete(`/api/MaterialMaster/api/V1/DeleteMaterialMaster?materialId=${materialId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// MASTER PLAN (4.3.11)
// ═══════════════════════════════════════════════════════════════════════════════
export const masterPlan = {
  getAll: () => api.get('/api/MasterPlan/api/V1/GetAllPlans'),
  getById: (planId) => api.get(`/api/MasterPlan/api/V1/GetPlanDetailsById?planId=${planId}`),
  save: (data) => api.post('/api/MasterPlan/api/V1/SaveMasterPlan', data),
  update: (data) => api.put('/api/MasterPlan/api/V1/UpdateMasterPlan', data),
  delete: (planId) => api.delete(`/api/MasterPlan/api/V1/DeleteMasterPlan?planId=${planId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// ITEM REGISTRATION
// ═══════════════════════════════════════════════════════════════════════════════
export const itemRegistration = {
  getAll: () => api.get('/api/ItemRegistration/api/V1/GetAllItems'),
  getById: (itemCode) => api.get(`/api/ItemRegistration/api/V1/ItemMasterGetByIdDetails?ItemCode=${itemCode}`),
  save: (data) => api.post('/api/ItemRegistration/api/V1/Save', data),
  update: (data) => api.put('/api/ItemRegistration/api/V1/Update', data),
  delete: (itemCode) => api.delete(`/api/ItemRegistration/api/V1/Delete?ItemCode=${itemCode}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE ORDER (4.4.2)
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseOrder = {
  getAll: () => api.get('/api/PurchaseOrder/api/v1/GetDetails'),
  getById: (poNo) => api.get(`/api/PurchaseOrder/api/v1/GetDetailsById?PONo=${poNo}`),
  getItems: (poNo) => api.get(`/api/PurchaseOrder/api/v1/GetByIdParentChildTableData?PONo=${poNo}`),
  generateItemCode: (data) => api.post('/api/PurchaseOrder/api/v1/POItemCodeGeneration', data),
  save: (data) => api.post('/api/PurchaseOrder/api/v1/Save', data),
  update: (data) => api.put('/api/PurchaseOrder/api/v1/Update', data),
  delete: (poNo) => api.delete(`/api/PurchaseOrder/api/V1/Delete?PONo=${poNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE ORDER CANCEL (4.4.4)
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseOrderCancel = {
  getGrid: () => api.get('/api/PurchaseOrderCancel/api/v1/GetGridDetails'),
  getById: (poId) => api.get(`/api/PurchaseOrderCancel/api/v1/GetPOCancelGetByIdDetails?POID=${poId}`),
  getOrderDetails: (poId) => api.get(`/api/PurchaseOrderCancel/api/v1/GetPOCOrderDetailsById?POId=${poId}`),
  getGridList: (poId) => api.get(`/api/PurchaseOrderCancel/api/v1/POCancelGridListGetById?POId=${poId}`),
  cancel: (data) => api.post('/api/PurchaseOrderCancel/api/V1/POCancelDetails', data),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE ORDER STATUS (4.4.6)
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseOrderStatus = {
  getAll: () => api.get('/api/PurchaseOrderStatus/api/v1/GetDetails'),
  getBranches: () => api.get('/api/PurchaseOrderStatus/api/V1/GetAllBranchDetails'),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PO PENDING QTY CANCEL (4.4.7)
// ═══════════════════════════════════════════════════════════════════════════════
export const poPendingQtyCancel = {
  getAll: () => api.get('/api/POPendingQtyCancel/api/v1/GetDetails'),
  getById: (poId) => api.get(`/api/POPendingQtyCancel/api/v1/GetDetailsById?POId=${poId}`),
  getPOList: () => api.get('/api/POPendingQtyCancel/api/v1/GetPOListDetails'),
  getPOGrid: (poNo) => api.get(`/api/POPendingQtyCancel/api/v1/GetPOByIdGridData?PONo=${poNo}`),
  save: (data) => api.post('/api/POPendingQtyCancel/api/v1/Save', data),
  update: (data) => api.put('/api/POPendingQtyCancel/api/v1/Update', data),
  delete: (poId) => api.delete(`/api/POPendingQtyCancel/api/V1/Delete?POId=${poId}`),
  getReport: (branch, fromDate, toDate) => api.get(`/api/POPendingQtyCancel/api/v1/POPendingQtyCancelReport?Branch=${branch}&fromDate=${fromDate}&toDate=${toDate}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// GRC DIRECT (4.8.1)
// ═══════════════════════════════════════════════════════════════════════════════
export const grcDirect = {
  getGrid: () => api.get('/api/GRCDirect/api/v1/GetGridDetails'),
  getById: (piNo) => api.get(`/api/GRCDirect/api/v1/GetDetailsById?PINO=${piNo}`),
  getEditDetails: (piNo) => api.get(`/api/GRCDirect/api/v1/EditByIdParentChildTableData?PINO=${piNo}`),
  generateItemCode: (data) => api.post('/api/GRCDirect/api/v1/ItemCodeGeneration', data),
  save: (data) => api.post('/api/GRCDirect/api/v1/Save', data),
  update: (data) => api.put('/api/GRCDirect/api/v1/Update', data),
  delete: (piNo) => api.delete(`/api/GRCDirect/api/V1/Delete?PINO=${piNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// GOODS RETURNS CHALLAN (4.8.5)
// ═══════════════════════════════════════════════════════════════════════════════
export const goodsReturnsChallan = {
  getAll: () => api.get('/api/GoodsReturnsChallan/api/v1/GetDetails'),
  getMRDetails: () => api.get('/api/GoodsReturnsChallan/api/v1/GetMRDetails'),
  getMRById: (mrId) => api.get(`/api/GoodsReturnsChallan/api/v1/GetMRDetailsById?MRId=${mrId}`),
  getById: (prNo) => api.get(`/api/GoodsReturnsChallan/api/v1/GetDetailsById?PRNO=${prNo}`),
  getDisplayById: (prNo) => api.get(`/api/GoodsReturnsChallan/api/v1/DisplayGoodsReturnsChallanGetById?PRNO=${prNo}`),
  getItemDetails: (itemCode) => api.get(`/api/GoodsReturnsChallan/api/v1/GRCItemCodeDetailsById?ItemCode=${itemCode}`),
  save: (data) => api.post('/api/GoodsReturnsChallan/api/v1/Save', data),
  update: (data) => api.put('/api/GoodsReturnsChallan/api/v1/Update', data),
  delete: (prNo) => api.delete(`/api/GoodsReturnsChallan/api/V1/Delete?PRNO=${prNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE INVOICE AGAINST PO (4.10.2)
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseInvoiceAgstPO = {
  getAll: () => api.get('/api/PurchaseInvoiceAgstPO/api/v1/GetDetails'),
  getById: (pvNo) => api.get(`/api/PurchaseInvoiceAgstPO/api/v1/GetDetailsById?PVNO=${pvNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// PURCHASE REPORTS
// ═══════════════════════════════════════════════════════════════════════════════
export const purchaseReports = {
  // PO Cancel Report
  poCancelGetDropdown: (lookupName) => api.get(`/api/POCancelReport/api/V1/GetDropDownList?LookupName=${lookupName}`),
  poCancelGetReport: (fromDate, toDate) => api.get(`/api/POCancelReport/api/V1/POCancelReportDetails?FromDate=${fromDate}&ToDate=${toDate}`),
  
  // PO Summary Report
  poSummaryGetDropdown: (lookupName) => api.get(`/api/POSummaryReport/api/V1/GetDropDownList?LookupName=${lookupName}`),
  poSummaryGetReport: (branch, fromDate, toDate) => api.get(`/api/POSummaryReport/api/V1/POSummaryReportDetails?Branch=${branch}&FromDate=${fromDate}&ToDate=${toDate}`),
  
  // PO Search
  poSearchGetDropdown: (searchType) => api.get(`/api/POSeach/api/V1/GetDropDownList?SearchType=${searchType}`),
  poSearchGetReport: (searchType, searchId) => api.get(`/api/POSeach/api/V1/POSearchReportDetails?SearchType=${searchType}&SearchId=${searchId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// JOB WORK - BILL OF MATERIAL
// ═══════════════════════════════════════════════════════════════════════════════
export const billOfMaterial = {
  getAll: () => api.get('/api/BillOfMaterial/api/V1/GetAllBOMs'),
  getById: (bomId) => api.get(`/api/BillOfMaterial/api/V1/GetBOMDetailsById?bomId=${bomId}`),
  save: (data) => api.post('/api/BillOfMaterial/api/V1/SaveBOM', data),
  update: (data) => api.put('/api/BillOfMaterial/api/V1/UpdateBOM', data),
  delete: (bomId) => api.delete(`/api/BillOfMaterial/api/V1/DeleteBOM?bomId=${bomId}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// JOB WORK - STOCK ORDER
// ═══════════════════════════════════════════════════════════════════════════════
export const stockOrder = {
  getAll: () => api.get('/api/StockOrder/api/V1/GetAllStockOrders'),
  getById: (stoNo) => api.get(`/api/StockOrder/api/V1/GetStockOrderDetailsById?stoNo=${stoNo}`),
  save: (data) => api.post('/api/StockOrder/api/V1/SaveStockOrder', data),
  update: (data) => api.put('/api/StockOrder/api/V1/UpdateStockOrder', data),
  delete: (stoNo) => api.delete(`/api/StockOrder/api/V1/DeleteStockOrder?stoNo=${stoNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// JOB WORK - ISSUE TO JOBBER
// ═══════════════════════════════════════════════════════════════════════════════
export const issueToJobber = {
  getAll: () => api.get('/api/IssueToJobber/api/V1/GetAllIssues'),
  getById: (issueNo) => api.get(`/api/IssueToJobber/api/V1/GetIssueDetailsById?issueNo=${issueNo}`),
  save: (data) => api.post('/api/IssueToJobber/api/V1/SaveIssue', data),
  update: (data) => api.put('/api/IssueToJobber/api/V1/UpdateIssue', data),
  delete: (issueNo) => api.delete(`/api/IssueToJobber/api/V1/DeleteIssue?issueNo=${issueNo}`),
};

// ═══════════════════════════════════════════════════════════════════════════════
// JOB WORK - RECEIPT FROM JOBBER
// ═══════════════════════════════════════════════════════════════════════════════
export const receiptFromJobber = {
  getAll: () => api.get('/api/ReceiptFromJobber/api/V1/GetAllReceipts'),
  getById: (receiptNo) => api.get(`/api/ReceiptFromJobber/api/V1/GetReceiptDetailsById?receiptNo=${receiptNo}`),
  save: (data) => api.post('/api/ReceiptFromJobber/api/V1/SaveReceipt', data),
  update: (data) => api.put('/api/ReceiptFromJobber/api/V1/UpdateReceipt', data),
  delete: (receiptNo) => api.delete(`/api/ReceiptFromJobber/api/V1/DeleteReceipt?receiptNo=${receiptNo}`),
};

export default {
  supplierMaster,
  supplierContracts,
  agentMaster,
  jobberMaster,
  transporterMaster,
  taxGroupMaster,
  taxMaster,
  tailorMaster,
  uomMaster,
  subUomMaster,
  purchaseOfficerMaster,
  hsnCodeMaster,
  divisionMaster,
  departmentMaster,
  categoryMaster,
  subCategoryMaster,
  brandMaster,
  styleMaster,
  sizeMaster,
  colorMaster,
  designMaster,
  itemRegistration,
  purchaseOrder,
  purchaseOrderCancel,
  purchaseOrderStatus,
  poPendingQtyCancel,
  grcDirect,
  goodsReturnsChallan,
  purchaseInvoiceAgstPO,
  purchaseReports,
  billOfMaterial,
  stockOrder,
  issueToJobber,
  receiptFromJobber,
};
